export const TOGGLE_PROPS = {
  active: false,
};
